// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1_qSX","overflowing":"ReadFullNote_overflowing__3_QXP"};